import { Box, CircularProgress, Divider, Typography } from '@mui/material';
import { useState } from 'react';
import DynamicFields from './DynamicFields';
import CustomButton from '../../../components/@extended/CustomButton';
import { useResponsive } from '../../../hooks/ResponsiveProvider';
import { getIn, useFormikContext } from 'formik';
import { checkFieldVisibility } from '../utils/dependsOnValidationService';

const DynamicCategory = (props) => {
  const { isSmallScreen } = useResponsive();
  const { _config, handleAddNewField } = props;
  const { values } = useFormikContext();
  // Track loading state for each category's "Add New" button
  const [loadingCategories, setLoadingCategories] = useState({});

  const handleAddNewClick = async (category) => {
    const categoryKey = category.key;
    // Set loading state for this specific category
    setLoadingCategories(prev => ({ ...prev, [categoryKey]: true }));
    
    try {
      await handleAddNewField(
        categoryKey,
        { subSectionKey: props.subSectionKey, sectionKey: props.sectionKey, categoryKey: categoryKey },
        props.values
      );
    } finally {
      // Clear loading state for this category
      setLoadingCategories(prev => ({ ...prev, [categoryKey]: false }));
    }
  };

  return (
    <>
      {_config.map((category, index) => {
        if (category.key === 'divider') {
          return (
            <Box key={`asd${index}`}>
              <Divider />
            </Box>
          );
        }

        const dependencySatisfied = checkFieldVisibility(category, values);
        const roleAllowed = category.access && (category.access == props.userSiteTrialRole || category.access.includes(props.userSiteTrialRole));
        const canRender = (dependencySatisfied && !category.access) || roleAllowed;

        let isAddNewEnabled = true;
        if (category.addNewEnabled !== undefined && category.addNewEnabled !== null && category.addNewEnabledValue !== undefined) {
          const addNewEnabledValue = getIn(values, category.addNewEnabled);
          isAddNewEnabled = addNewEnabledValue === category.addNewEnabledValue;
        }

        const isLoading = loadingCategories[category.key] || false;

        return (
          canRender && (
            <Box key={`asd${index}`}>
              {category.label && (
                <Box sx={{ padding: isSmallScreen ? 1 : 3, paddingBottom: 1 }}>
                  <Typography variant="h5">{category.label}</Typography>
                </Box>
              )}
              {category.helperLabel && (
                <Box sx={{ padding: 3, paddingBottom: 2, paddingTop: 0 }}>
                  <Typography variant="subtitle2">{category.helperLabel}</Typography>
                </Box>
              )}
              <DynamicFields {...props} _config={category.fields} parentKey={category.key} />
              {category.addNew && (
                <Box sx={{ display: 'flex', justifyContent: category?.addNewJustifyContent ? category?.addNewJustifyContent : 'flex-end', pb: 2 }}>
                  <CustomButton
                    variant="outlined"
                    onClick={() => handleAddNewClick(category)}
                    disabled={!isAddNewEnabled || isLoading}
                    startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
                  >
                    {isLoading ? 'Adding...' : 'Add New'}
                  </CustomButton>
                </Box>
              )}
              {(category.showBottomDivider === undefined || category.showBottomDivider) && <Divider />}
            </Box>
          )
        );
      })}
    </>
  );
};

export default DynamicCategory;
